export default class UpdateKBContentDraftRequest {
  public title = '';
  public slug = '';
  public content = '';
  public tags: string[] = [];
  public parentId = '';
  public order = 0;
  public visibility = 'internal';
  public relatedContentIds: string[] = [];
  public searchKeywords: string[] = [];
}
